import React, { Component } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const TabAll = [
    {
        image: '01',
        bigImage: '/assets/images/portfolio/big/dp-big--portfolio-01.jpg',
        category: 'Aplicación móvil - Flutter',
        title: 'Gestión de turismo de la ciudad de Tamaulipas',
        link: 'tamaulipas-app-details'
    },
    {
        image: '02',
        bigImage: '/assets/images/portfolio/big/dp-big--portfolio-02.jpg',
        category: 'Página web - Laravel',
        title: 'Gestión de turismo de la ciudad de Tamaulipas',
        link: 'tamaulipas-web-details'
    },
    {
        image: '06',
        bigImage: '/assets/images/portfolio/big/dp-big--portfolio-06.jpg',
        category: 'Aplicación móvil - Flutter',
        title: 'Aplicación de mercado de segunda mano e inmuebles en América',
        link: 'zerobolas-details'
    },
    {
        image: '03',
        bigImage: '/assets/images/portfolio/big/dp-big--portfolio-03.jpg',
        category: 'Aplicación móvil - Flutter',
        title: 'Información de puestos de lotería alrededor de España',
        link: 'fenamix-details'
    },
    {
        image: '07',
        bigImage: '/assets/images/portfolio/big/dp-big--portfolio-07.jpg',
        category: 'Aplicación móvil - Flutter',
        title: 'Aplicación de lista de la compra compartida en tiempo real',
        link: 'go2market-details'
    },
    {
        image: '04',
        bigImage: '/assets/images/portfolio/big/dp-big--portfolio-04.jpg',
        category: 'Página web - React',
        title: 'Aplicación de apoyo a estudios en Academia para Oposiciones',
        link: 'apolex-details'
    },
    {
        image: '05',
        bigImage: '/assets/images/portfolio/big/dp-big--portfolio-05.jpg',
        category: 'Aplicación móvil - Flutter',
        title: 'Aplicación de gestión de aforo del evento Congreso Fenamix V.',
        link: 'fenamix-aforo-details'
    },
    {
        image: '08',
        bigImage: '/assets/images/portfolio/big/dp-big--portfolio-08.jpg',
        category: 'Red de servidores',
        title: 'Gestión y mantenimiento de servidores para Influencers (Ibai, IlloJuan, etc)',
        link: 'cutreland-minecraft-ibai-illojuan-twitch'
    }
]

const TabTwo = TabAll.filter((value) => value.category.includes("Aplicación"))

const TabThree = TabAll.filter((value) => value.category.includes("web"))

const TabFour = TabAll.filter((value) => value.category.includes("servidores"))

class TabStyleThree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tab1: 0,
            tab2: 0,
            tab3: 0,
            tab4: 0,
            isOpen: false,
        };
    }
    render() {
        const {column } = this.props;
        return (
            <div>
                <Tabs>
                    <div className="row text-center">
                        <div className="col-lg-12">
                            <div className="tablist-inner">
                                <TabList className="pv-tab-button text-center mt--0">
                                    <Tab><span>Todos los proyectos</span></Tab>
                                    <Tab><span>Aplicaciones móviles</span></Tab>
                                    <Tab><span>Proyectos Web</span></Tab>
                                    <Tab><span>Otros proyectos</span></Tab>
                                </TabList>
                            </div>
                        </div>
                    </div>

                    <TabPanel className="row row--35">
                        {TabAll.map((value , index) => (
                            <div className={`${column}`} key={index}>
                                <div className="item-portfolio-static">
                                    <div>
                                        <div className="portfolio-static">
                                            <div className="thumbnail-inner">
                                                <div className="thumbnail">
                                                    <a href={value.link}>
                                                        <img src={`/assets/images/portfolio/dp-portfolio-${value.image}.jpg`} alt="Portfolio Images"/>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content">
                                                <div className="inner">
                                                    <p>{value.category}</p>
                                                    <h4><a href={value.link}>{value.title}</a></h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </TabPanel>
                    <TabPanel className="row row--35">
                        {TabTwo.map((value , index) => (
                            <div className={`${column}`} key={index}>
                     
                                <div className="item-portfolio-static">
                                    <div>
                                        <div className="portfolio-static">
                                            <div className="thumbnail-inner">
                                                <div className="thumbnail">
                                                    <a href={value.link}>
                                                        <img src={`/assets/images/portfolio/dp-portfolio-${value.image}.jpg`} alt="Portfolio Images"/>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content">
                                                <div className="inner">
                                                    <p>{value.category}</p>
                                                    <h4><a href={value.link}>{value.title}</a></h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </TabPanel>

                    <TabPanel className="row row--35">
                        {TabThree.map((value , index) => (
                            <div className={`${column}`} key={index}>
                             
                                <div className="item-portfolio-static">
                                    <div>
                                        <div className="portfolio-static">
                                            <div className="thumbnail-inner">
                                                <div className="thumbnail">
                                                    <a href={value.link}>
                                                        <img src={`/assets/images/portfolio/dp-portfolio-${value.image}.jpg`} alt="Portfolio Images"/>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content">
                                                <div className="inner">
                                                    <p>{value.category}</p>
                                                    <h4><a href={value.link}>{value.title}</a></h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </TabPanel>

                    <TabPanel className="row row--35">
                        {TabFour.map((value , index) => (
                            <div className={`${column}`} key={index}>
                           
                                <div className="item-portfolio-static">
                                    <div>
                                        <div className="portfolio-static">
                                            <div className="thumbnail-inner">
                                                <div className="thumbnail">
                                                    <a href={value.link}>
                                                        <img src={`/assets/images/portfolio/dp-portfolio-${value.image}.jpg`} alt="Portfolio Images"/>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="content">
                                                <div className="inner">
                                                    <p>{value.category}</p>
                                                    <h4><a href={value.link}>{value.title}</a></h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </TabPanel>
                </Tabs>
            </div>
        )
    }
}


export default TabStyleThree
